// src/api/index.js
import axios from "axios";

const HOST =
  typeof window !== "undefined" ? window.location.hostname : "";
const IS_LOCAL = HOST === "localhost" || HOST === "127.0.0.1";

function getServerUrl() {
  // Permite sobrescribir desde window.__API_URL__ si alguna vez lo necesitas
  if (typeof window !== "undefined" && window.__API_URL__) {
    return window.__API_URL__;
  }

  if (IS_LOCAL) return "http://localhost:4001";
  if (HOST.endsWith("owius.com")) return "https://planeta-api.evenely.com";
  return "https://planeta-api.evenely.com"; // fallback
}

export const SERVER_URL = getServerUrl();
export const API = `${SERVER_URL}/api`;

export const baseClient = () =>
  axios.create({ baseURL: API });

export const authClient = () =>
  axios.create({ baseURL: API, withCredentials: true });
